import { render, staticRenderFns } from "./WasteDiagnosticPage.vue?vue&type=template&id=26433ece&scoped=true&"
import script from "./WasteDiagnosticPage.vue?vue&type=script&lang=js&"
export * from "./WasteDiagnosticPage.vue?vue&type=script&lang=js&"
import style0 from "./WasteDiagnosticPage.vue?vue&type=style&index=0&id=26433ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26433ece",
  null
  
)

export default component.exports